import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import { Text } from 'shared/components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import DateInput from './components/date'
import FileInput from './components/file'
import ToggleInput from './components/toggle'
import PasswordInput from './components/password'
import TextareaInput from './components/textarea'
import { Select, AsyncSelect, Tags } from './components/select'

import defaultRenderer from './renderers'

import { INPUT_TYPES } from './input.types'

import * as styles from './styles'

const defaultErrorRender = (error) => (
  <Text as="div" css={styles.errorContainer}>
    {error.message}
  </Text>
)

// TODO:  Move to React.createElement

const inputs = {
  [INPUT_TYPES.TAGS]: (props) => <Tags {...props} />,
  [INPUT_TYPES.SELECT]: (props) => <Select {...props} />,
  [INPUT_TYPES.ASYNC_SELECT]: (props) => <AsyncSelect {...props} />,
  [INPUT_TYPES.TOGGLE]: (props) => <ToggleInput {...props} />,
  [INPUT_TYPES.FILE]: (props) => <FileInput {...props} />,
  [INPUT_TYPES.DATE]: (props) => <DateInput {...props} />,
  [INPUT_TYPES.PASSWORD]: (props) => <PasswordInput {...props} />,
  // eslint-disable-next-line react/prop-types
  [INPUT_TYPES.TEXTAREA]: ({ onInternalKeyDown, onKeyDown, ...props }) => (
    <TextareaInput {...props} onKeyDown={onInternalKeyDown || onKeyDown} />
  ),
}
const rendererProxy = ({ type, ...props }) => {
  if (inputs[type]) return inputs[type](props)
  return defaultRenderer(props)
}

const InputComponent = ({
  label,
  icon,
  strictShort,
  strictLong,
  strictSuperLong,
  error,
  renderError = defaultErrorRender,
  renderComponent = rendererProxy,
  ...props
}) => {
  const inputRef = useRef()
  return (
    <div css={styles.container}>
      {label && (
        <Text gray block as="label" size={16} css={styles.label(props)}>
          {label}
        </Text>
      )}
      <div
        css={[
          styles.container,
          strictShort && styles.strictShort,
          strictLong && styles.strictLong,
          strictSuperLong && styles.strictSuperLong,
        ]}
      >
        <div
          css={[
            styles.controlContainer({ ...props, strictSuperLong }),
            icon && styles.controlIconed,
          ]}
        >
          {renderComponent({ ...props, strictSuperLong }, inputRef)}
          {icon && <FontAwesomeIcon icon={icon} css={styles.icon} />}
        </div>
        {props.showError && renderError(error)}
      </div>
    </div>
  )
}

InputComponent.propTypes = {
  icon: PropTypes.string,
  label: PropTypes.string,
  isRequired: PropTypes.bool,
  strictShort: PropTypes.bool,
  strictLong: PropTypes.bool,
  strictSuperLong: PropTypes.bool,
  renderError: PropTypes.func,
  showError: PropTypes.bool,
  error: PropTypes.shape({ message: PropTypes.string }),
  renderComponent: PropTypes.func,
  onInternalKeyDown: PropTypes.func,
  type: PropTypes.string,
  size: PropTypes.string,
  bordered: PropTypes.bool,
}

export default InputComponent
